
import crud from "./_crud";
import { callApi } from 'utils/api'

const actions = crud('location', 'la ubicación', 'las ubicaciones');

const loadWialonGeofences = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/geofences`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_GEOFENCES_WIALON`,
			response: res.body,
		})

		return res.body
	}
}

const loadWialonGeofencesDetail = (params) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/geofences_detail`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(params),
		})

		dispatch({
			type: `GET_GEOFENCES_DETAIL_WIALON`,
			response: res.body,
		})

		return res.body
	}
}

const loadWialonGeofencesDetailBatch = (params) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/geofences_detail_batch`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(params),
		})

		dispatch({
			type: `GET_GEOFENCES_DETAIL_BATCH_WIALON`,
			response: res.body,
		})

		return res.body
	}
}

const loadWialonGeofencesTree = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/geofences_tree`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_GEOFENCES_TREE_WIALON`,
			response: res.body,
		})

		return res.body
	}
}

const refreshWialonGeofencesTree = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/refresh_geofences_tree`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_GEOFENCES_TREE_WIALON`,
			response: res.body,
		})

		return res.body
	}
}

const loadDriverWialonGeofences = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/driver_geofences`, {
			method: 'GET',
			headers: {
				Authorization: state.app.driver?.token || '',
			},
		})

		dispatch({
			type: `GET_GEOFENCES_WIALON`,
			response: res.body,
		})

		return res.body
	}
}

const getOptimizedRoute = (params) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/maps_utils/optimize_route`, {
			method: 'POST',
			body: JSON.stringify(params),
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_OPTIMIZED_ROUTE`,
			response: res.body,
		})

		return res.body
	}
}

const getStopsData = (params) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/maps_utils/route_stops_data`, {
			method: 'POST',
			body: JSON.stringify(params),
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_STOPS_DATA`,
			response: res.body,
		})

		return res.body
	}
}

const getRouteImg = (params) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/maps_utils/route_img`, {
			method: 'POST',
			body: JSON.stringify(params),
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_ROUTE_IMG`,
			response: res.body,
		})

		return res.body
	}
}

export default {
	...actions,
	loadWialonGeofences,
	loadDriverWialonGeofences,
	getOptimizedRoute,
	getStopsData,
	getRouteImg,
	loadWialonGeofencesTree,
	refreshWialonGeofencesTree,
	loadWialonGeofencesDetail,
	loadWialonGeofencesDetailBatch
}